import React from 'react';
import ReactGA from "react-ga";

export default function FaqPage() {

	return (
		<section id="body">
			<div className="container">
				<div className="row shadow title position-relative">
					<div className="col-12">
						<h2 className="text-center m-5 text-white fw-bold">Frequently Asked Questions</h2>
					</div>
				</div>
				<div className="row content">
					<div className="col-1"></div>
					<div className="col-10 shadow bg-white rounded">
												<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">1.</label>
								<label className="col-10 col-form-label">
									Who is the insurer for this policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									This bicycle insurance is underwritten by Allianz General Insurance Company (Malaysia) Berhad (Allianz).
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">2.</label>
								<label className="col-10 col-form-label">
									If I am a foreigner or Malaysian Permanent Resident (PR), can I purchase this policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Yes, you can purchase this policy as long as you are a Malaysian PR or hold a valid employment pass, dependant's pass, work pass, long-term visit pass or student pass in Malaysia.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">3.</label>
								<label className="col-10 col-form-label">My bicycle is 8 years, can I still buy this bicycle insurance?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">No. This insurance covers bicycle of 5 years or lower (calculated from the date of manufacture).
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">4.</label>
								<label className="col-10 col-form-label">Is there a free-look period?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">No. There is no free-look period for this policy.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">5.</label>
								<label className="col-10 col-form-label">I bought my bicycle secondhand; can I insure my bicycle?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Yes, we accept brand new and used/secondhand bicycle. However, your used/secondhand bicycle must be of 5 years or lower (calculated from the date of manufacture).
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">6.</label>
								<label className="col-10 col-form-label">When does my policy takes effect?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									The coverage takes effect upon receipt of successful premium payment by Allianz General and the customer will receive the confirmation of cover email/message stipulating the coverage period. 
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">7.</label>
								<label className="col-10 col-form-label">Are there any special conditions of the policy that I should know of?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								<ul>
								<li>The policy excludes theft of bicycle in the open unless the bicycle is under the control and surveillance of the Insured.</li>
								<li>Damage or loss of part is restricted to occurrence arising from accidental collision or overturning or collision overturning consequent upon mechanical breakdown in the course of cycling only.</li>
								<li>The basis of settlement of this policy shall be on market value basis and exclude wear & tear, betterment, improvement and advancement except for bicycles less than 1 year old (calculated from the date of manufacture).</li>
								<li>The basis of settlement for bicycles less than 1 year old (calculated from the date of manufacture) shall be based on replacement cost and exclude the betterment, improvement and advancement.</li>
								<li>The age of the bicycle is up to 5 years only (calculated from the date of manufacture).</li>
								</ul>
								</label>

							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">8.</label>
								<label className="col-10 col-form-label">What are the exclusions for this policy?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								<ul>
								<li>Loss or damage for racing, pace-making, reliability trial, demonstration or speed-testing.</li>
								<li>Loss or damage to the bicycle whilst it is operated by any other cyclist other than an authorized cyclist.</li>
								<li>Loss or damage to the bicycle when it is used beyond its permitted limitations.</li>
								<li>Loss or damage to the bicycle when the cyclist is under influence of intoxicating liquor or drugs.</li>
								<li>Loss of accessories/parts unless the whole bicycle is stolen at the same time.</li>
								<li>Loss or damage to the bicycle when in transit as unaccompanied baggage including during loading and unloading.</li>
								<li>Loss or damage due to wear and tear, depreciation, gradual deterioration, rust, vermin, war and invasion.</li>
								<li>Loss or damage due to convulsion of nature.</li>
								<li>Loss or damage caused by the willful or dishonest act of the Insured or the dishonest act of any person whom the bicycle is entrusted</li>
								<li>Loss or damage due to overloading/over straining</li>
								<li>Loss or damage for which the seller or manufacturer of the bicycle is responsible either by law or under a contract</li>
								</ul>
							</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">9.</label>
								<label className="col-10 col-form-label">Does this insurance cover theft?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Yes, claim for theft will be paid if your bicycle is parked in a secure, well-lit and surveillance area or there is evidence of forcible entry or break-in.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">10.</label>
								<label className="col-10 col-form-label">How to determine the value of sum insured for my bicycle?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									The value of your bicycle will be determined by the purchase invoice or receipt or your preferred amount.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">11.</label>
								<label className="col-10 col-form-label">How will I know if my online purchase is successful?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									When you complete the purchase, you will get a confirmation message on your screen. At the same time, you will receive
									confirmation via email. You will be receiving your policy from Allianz within 5 - 7 working days. If you do not receive
									any confirmation or/and policy, please reach out to us via <a href="mailto:instaPol@howdengroup.com">instaPol@howdengroup.com</a>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">12.</label>
								<label className="col-10 col-form-label">Is my bicycle covered if it is stolen from the coffee shop after my ride?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									As long as your bicycle is under control and surveillance of your direct line of sight.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">13.</label>
								<label className="col-10 col-form-label">Can I upgrade my coverage if I upgrade to a new bicycle?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									No. You will have to purchase a new policy for the new bicycle. However, you may choose to cancel the coverage for the older bike by writing to us at instaPol@howdengroup.com or Allianz; and a refund of the premium based on Allianz's short period rates will apply.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">14.</label>
								<label className="col-10 col-form-label">Is my bicycle covered if I am insured at a lower sum insured?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									If your bicycle amount insured is less than the actual value at the time of loss (i.e. under insurance), you are deemed to have self-insured the difference. For example, the sum insured purchased was RM5,000. However, the value of the bicycle at the time of loss is RM10,000. The insurance will pay for the proportion of the loss which relates to the sum insured purchased divided by actual value.
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
								The calculation for the claim amount as follows (assuming that your bicycle is 1 years old or older):
								</label>
							</div>
							
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">	
								<b>Amount claimable/payable : </b>
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">	
								(Claim/loss amount incurred x Insured amount) / Market value of insured bicycle at the date of loss = Payable amount to insured
								</label>
							</div>
							
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">	
								<b>Example of Calculation :</b>
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">	
								(RM8,000 x RM5,000) / RM10,000 = RM4,000
								</label>
							</div>								
							
							
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">15.</label>
								<label className="col-10 col-form-label">For any repair or replacement part, only used part is covered? Can I replace with new parts?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									The coverage pays repair, new and replacement parts as long as the claim amount is within the sum insured purchased.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">16.</label>
								<label className="col-10 col-form-label">Does this bicycle coverage pay according to market value or agreed value?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									This basis of settlement shall be on market value basis and exclude wear & tear and betterment, improvement and advancement except for bicycles less than 1 year old. 
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">17.</label>
								<label className="col-10 col-form-label">Is there any Excess on repairs should my bicycle suffer damages?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Yes, there is a minimum excess of RM750 or 15% of loss, whichever is higher which you will have to bear. Excess applies to all types of claims including theft.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">18.</label>
								<label className="col-10 col-form-label">What do you mean by Excess?</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									For simple understanding, your insurance excess is the out of pocket amount you have to pay when making a claim. For example, if excess is RM750 and your repair claim is RM5,000, that means you'll have to pay RM750, while your Allianz pays the remaining RM4,250.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">19.</label>
								<label className="col-10 col-form-label">What should I do should if there is a claim?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">
									Notify us at <a href="mailto:instaPol@howdengroup.com">instaPol@howdengroup.com</a> immediately. Supporting documents for 
									claims submission:
									<ul>
										<li>Completed claims notification form</li>
										<li>Repair or replacement bill</li>
										<li>Pictures of damage bicycle / parts</li>
										<li>Proof of ownership (if available)</li>
									</ul>

									Police report is mandatory for:
									<ul>
										<li>Theft claims </li>
										<li>Accidental claim above RM3,000</li>
									</ul>
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">20.</label>
								<label className="col-10 col-form-label">Is my bicycle insured when I bring it along with me when I travel out of Malaysia?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">No, the insurance covers within Malaysia only.</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">21.</label>
								<label className="col-10 col-form-label">Can I transfer this insurance cover to the person I gave the bicycle to?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">No, the insurance cover follows the insured person and is not transferable.
								</label>
							</div>
						</div>
						<div className="question">
							<div className="row text-primary fw-bold">
								<label className="col-1 col-form-label text-center">22.</label>
								<label className="col-10 col-form-label">Is there any after sales & claims services offered to customer after insurance purchase?
								</label>
							</div>
							<div className="row">
								<div className="col-1"></div>
								<label className="col-10 col-form-label text-justify">Yes, instaPol from Howden provides (1) Product Advisory, offering ongoing support to clients regarding insurance-related queries post-purchase (2) Assistance in changing / updating policy details (3) Claims assistance. Alternatively, you may also contact your chosen insurance company or takaful operator.
								</label>
							</div>
						</div>
					</div>
					<div className="col-1"></div>
				</div>
			</div>
				
			<div className="row footer my-5">
				<div className="col-12 text-end">
					<a className="btn btn-success me-3" href="/Landing">Return to Home Page</a>
					<a className="btn btn-success" href="/BIKE">Get Quote</a>
				</div>
			</div>
		</section>
	);
}